import { render, staticRenderFns } from "./DealerList.vue?vue&type=template&id=2d1d0232"
import script from "./DealerList.vue?vue&type=script&lang=js"
export * from "./DealerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports